"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerInfoStyled = exports.BannerAlertStyled = exports.BannerStyled = exports.BannerWrapperStyled = exports.BannerAnimateStyled = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var themes_1 = require("../../themes");
var mixins_1 = require("../../themes/mixins");
var greyColor15 = themes_1.colors.greyColor15, lightRed = themes_1.colors.lightRed, lightGreen = themes_1.colors.lightGreen, lightYellow = themes_1.colors.lightYellow, red = themes_1.colors.red, green = themes_1.colors.green, yellow = themes_1.colors.yellow, greyColor5 = themes_1.colors.greyColor5, greyColor100 = themes_1.colors.greyColor100, white = themes_1.colors.white;
var colorConfig = {
    red: { bgColor: lightRed, color: red },
    green: { bgColor: lightGreen, color: green },
    yellow: { bgColor: lightYellow, color: yellow },
    grey: { bgColor: greyColor5 },
    dark: { bgColor: greyColor100 },
};
exports.BannerAnimateStyled = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  ", "\n  height: ", "px;\n"], ["\n  overflow: hidden;\n  ", "\n  height: ", "px;\n"])), (0, mixins_1.transition)("height"), function (_a) {
    var height = _a.height;
    return height;
});
exports.BannerWrapperStyled = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  padding: 0.5rem 2rem;\n  position: relative;\n  gap: 1rem;\n  border-bottom: 1px solid ", ";\n  background-color: ", ";\n\n  ", "\n\n  color: ", ";\n\n  ", " {\n    align-items: center;\n  }\n"], ["\n  display: flex;\n  padding: 0.5rem 2rem;\n  position: relative;\n  gap: 1rem;\n  border-bottom: 1px solid ", ";\n  background-color: ", ";\n\n  ", "\n\n  color: ", ";\n\n  ", " {\n    align-items: center;\n  }\n"])), greyColor15, function (_a) {
    var _b;
    var color = _a.color;
    return (_b = colorConfig[color]) === null || _b === void 0 ? void 0 : _b.bgColor;
}, function (_a) {
    var _b;
    var bottomStroke = _a.bottomStroke, color = _a.color;
    return bottomStroke && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      box-shadow: inset 0px -2px 0px ", ";\n    "], ["\n      box-shadow: inset 0px -2px 0px ", ";\n    "])), (_b = colorConfig[color]) === null || _b === void 0 ? void 0 : _b.color);
}, function (_a) {
    var color = _a.color;
    return (color === "dark" ? white : "");
}, (0, mixins_1.mediaQuery)("sm"));
exports.BannerStyled = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n"])));
exports.BannerAlertStyled = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: sticky;\n  z-index: 1000000000;\n  width: 100%;\n  ", ";\n\n  ", "\n"], ["\n  position: sticky;\n  z-index: 1000000000;\n  width: 100%;\n  ", ";\n\n  ", "\n"])), function (_a) {
    var top = _a.top;
    return (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    top: ", "px;\n  "], ["\n    top: ", "px;\n  "])), top);
}, (0, mixins_1.transition)("top"));
exports.BannerInfoStyled = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: sticky;\n  z-index: 1000000000;\n  top: 0;\n  width: 100%;\n"], ["\n  position: sticky;\n  z-index: 1000000000;\n  top: 0;\n  width: 100%;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
